<!-- Camera -->
<div class="camera-bar">
  <!-- Center camera -->
  <!-- <button
    app-scene-button
    *ngIf="showCenter"
    (click)="centerCamera()"
    matTooltip="Center model point of view"
    matTooltipPosition="left">
    
    <app-icon icon="crosshairs"></app-icon>
  </button> -->

  <app-pillbox orientation="vertical" [padding]="expandNav ? 'dense' : 'none'" *ngIf="showNav">
    <div class="camera-bar__nav" [ngClass]="{'camera-bar__nav--expand': expandNav}">
      <!-- Pan Mode -->
      <app-pin-button
        [selected]="(panMode$ | async) === 'pan'"
        *ngIf="showPan"
        icon="arrows-alt"
        type="ghost"
        (click)="togglePan()"
        matTooltip="Pan"
        matTooltipPosition="left">
      </app-pin-button>
      
      <!-- Zoom In -->
      <app-pin-button
        *ngIf="showZoom"
        type="ghost"
        icon="plus"
        (touchstart)="setZoom('in')"
        (mousedown)="setZoom('in')"
        (touchend)="setZoom('')"
        (mouseup)="setZoom('')"
        (mouseleave)="setZoom('')"
        matTooltip="Zoom In"
        matTooltipPosition="left">
      </app-pin-button>
  
      <!-- Zoom Out -->
      <app-pin-button
        *ngIf="showZoom"
        type="ghost"
        icon="minus"
        (touchstart)="setZoom('out')"
        (mousedown)="setZoom('out')"
        (touchend)="setZoom('')"
        (mouseup)="setZoom('')"
        (mouseleave)="setZoom('')"
        matTooltip="Zoom Out"
        matTooltipPosition="left">
      </app-pin-button>

      <!-- Return to chapter position -->
      <app-pin-button
        *ngIf="showResetPosition"
        icon="dot-circle"
        type="ghost"
        (click)="returnToChapterCamera()"
        matTooltip="Recenter 3D model"
        matTooltipPosition="left">
      </app-pin-button>
    </div>
    
    <!-- Expand Nav -->
    <app-pin-button 
      icon="location-arrow"
      type="ghost"
      [selected]="expandNav"
      [matTooltip]="expandNav ? 'Close 3D controls' : '3D controls'"
      matTooltipPosition="left"
      (click)="toggleNav();">
    </app-pin-button>

  </app-pillbox>  

  <!-- Reset -->
  <ng-container *ngIf="showResetScene && (selectedChapterModified$ | async)">
    <button
      @show
      app-scene-button
      (click)="resetChapter()"
      matTooltip="Reset"
      matTooltipPosition="left">

      <app-icon icon="sync-alt"></app-icon>
    </button>
  </ng-container>
</div>